export default "__VITE_ASSET__6699ce03__"